import React from "react";
import logo from "../../media/images/logo.png";
// import logo from "../../media/images/logo.jpeg";
import { Link } from "react-router-dom";

const HomeNav = () => {
  return (
    <div>
      <div className="home-nav">

        <div className="home-nav-top">
          <div className="home-nav-top-logo">
            {/* <img src={logo} alt="" /> */}



            <div className="bhumu-company-logo-text">
               <div>Repair</div>
              <div>Buddy</div>
               </div>


          </div>
          <div className="home-nav-top-details">
            <div className="home-nav-top-col">
              <div className="home-nav-top-icon">
                <i class="fa-solid fa-location-dot"></i>
              </div>
              <div className="home-nav-top-text">
                <div className="home-nav-top-heading-1">Free Contact</div>
                <div className="home-nav-top-heading-2">
                Delhi NCR
                </div>
              </div>
            </div>

            <div className="home-nav-top-col">
              <div className="home-nav-top-icon">
              <i class="fa-solid fa-envelope-open-text"></i>
              </div>
              <div className="home-nav-top-text">
                <div className="home-nav-top-heading-1">Online Support</div>
                <div className="home-nav-top-heading-2">
                  repairbuddyonline@gmail.com
                </div>
              </div>
            </div>

            {/* <Link to="tel:+919220407009" target="blank" className="home-nav-top-col">
              <div className="home-nav-top-icon">
                <i class="fa-solid fa-phone-volume"></i>
              </div>
              <div className="home-nav-top-text">
                <div className="home-nav-top-heading-1">Free Contact</div>
                <div className="home-nav-top-heading-2">
                +91 9220-407-009
                </div>
              </div>
            </Link> */}
          </div>
        </div>


        <div className="home-nav-bottom">

        <div className="navbar">
        <div className="navbar-col-1">
          <div className="navbar-menu">
            <a href="#price-list">PRICE LIST </a>
            <a href="#about-us">ABOUT US</a>
            <a href="#why-us">WHY US</a>
            <a href="#testimonial">TESTIMONIALS</a>
            <a href="#faqs">FAQS</a>
            {/* <a href="">AMC PLANS</a> */}
            <div></div>
          </div>
        </div>
        <div className="navbar-col-2">
        {/* <div className="navbar-option"><i class="fa-solid fa-globe"></i> Eng <i class="fa-solid fa-angle-down"></i></div> */}
        <a  className="navbar-button" href="#book-now" >Book Service Now</a>
        {/* <Link to="https://wa.me/+919220407009?text=Hello! I need free estimate for AC Service. Please contact me." target="blank" className="navbar-button">Get Free Estimate</Link> */}

        </div>
      </div>
          
          
        </div>

        
      </div>

      
    </div>
  );
};

export default HomeNav;
